module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-FUNDLY.6d24737b.png";